import { render, staticRenderFns } from "./HomeRecentInspections.vue?vue&type=template&id=6b7ff68d&"
import script from "./HomeRecentInspections.vue?vue&type=script&lang=js&"
export * from "./HomeRecentInspections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports